import { makeAuthenticatedRequest } from "./api";

export const getTopicScores = async (classroomId, studentId) => {
  try {
    const URL = `/topics/${classroomId}/scores${
      studentId ? `?studentId=${studentId}` : ""
    }`;
    return await makeAuthenticatedRequest(URL, "GET", null)
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .then((data) => {
        return { ok: true, data: data };
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error fetching topic scores:", error);
    return { ok: false, error: error };
  }
};

export const getSubjectPerformance = async (
  classroomId,
  subjectId,
  studentId
) => {
  const URL = `/examAttempt/user/${classroomId}/${subjectId}${
    studentId ? `?studentId=${studentId}` : ""
  }`;
  return await makeAuthenticatedRequest(URL, "GET", null).then((response) => {
    if (!response.ok) {
      return { ok: false, error: response };
    }
    return response.json();
  });
};
